module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "calibre9"
  }, [_vm._v("Erster Akt")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Ein Gemach auf dem Bischofsberge, einem\naltertümlichen Landhause, in Weinbergen und Gärten an der Saale\ngelegen. Die Hinterwand zeigt in einer tiefen Nische der dicken\nMauer ein breites Fenster mit Bleifassungen. Durch das Fenster, das\noffensteht, erblickt man Türme und Dächer einer alten Stadt am\njenseitigen Talabhange. Es ist Naumburg. Die Nische enthält zu\nbeiden Seiten altes Gestühl, auf stufenartiger Erhöhung aus\ndemselben Sandstein, der den Fußboden bildet; dazwischen steht ein\nSpinnrad. Die Decke des Zimmers ist gewölbt. Aus ihrer Mitte herab\nhängt ein schöner Hängeleuchter aus Messing, mit Lichtern, über\neinem großen, runden und schweren Eichentisch. Mit einem schwarzen,\ngoldgesäumten Samt bedeckt, trägt dieser Tisch einige alte silberne\nGefäße und einen vergoldeten, gebuckelten Pokal. Die Wand links\nschmückt ein alter Kamin. Zu seinen beiden Seiten sehr alte,\nnachgedunkelte Bilder, Bischöfe im Ornat darstellend. Die Wand\ngegenüber zeigt einen mächtigen Renaissanceschrank. Kleine\nRundpforten sind hinter dem Kamin und rechts vor dem Schrank.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Es ist gegen Mittag eines Tages Anfang\nOktober.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Auf zwei hochlehnigen Stühlen einander gegenüber\nsitzen der alte Herr Ruschewey im ländlichen Hausanzug und ein\nfremder ältlicher Herr, der Hut, Regenschirm und Überzieher auf dem\nSchoße liegen hat. Ruschewey ist gebräunt, bärtig, frisch und\njovial. Der Herr, von nicht sehr einnehmendem Äußeren, bebrillt und\nin Gummischuhen, hat den Typus des Stubengelehrten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Ja, ja! Erlauben Sie\nmir, daß ich mir mittlerweile meine Pfeife anstecke?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Oh, ich habe nichts zu\nerlauben, Herr Ruschewey. Ich bin nur gekommen in aller\nBescheidenheit . . . ich wollte mich nur in aller Bescheidenheit\nnach dem Befinden der jungen Damen untertänigst erkundigen, denen,\nwie ich zu meinem Schmerze gelesen habe, das unerbittliche Fatum\nMutter und Vater so früh entrissen hat. Geht es den jungen Damen\neinigermaßen zufriedenstellend, wenn ich fragen darf? Natürlich den\nUmständen angemessen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Jawohl, ja! Es geht\nmeinen Nichten recht leidlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Ja, ja, es war ein recht\nschwerer Schlag. So schnell nacheinander Mutter und Vater. –\n"), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page8",
      "title": "987/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey.")]), _vm._v(" Jawohl, ja! Das heißt:\nIn welchem Blatt steht denn das? Meine arme Schwägerin, die ja\nallerdings wirklich zu gut für diese Erde gewesen ist, hat unser\nhimmlischer Vater nämlich bereits vor fünfzehn Jahren zu sich\ngenommen. Volle vierzehn Jahre hat Bruder Bertold sie überlebt. Ich\nfürchtete damals, er würde es nicht sechs Monate aushalten. Wo\nhaben Sie eigentlich meinen Bruder kennengelernt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr.")]), _vm._v(" Seltsamerweise in einem\nAntiquitätenladen zu Amsterdam. Ich kann mich noch recht genau\nerinnern. Es war in einer recht wenig für die Anknüpfung\ngesellschaftlicher Beziehungen geeigneten Gegend der Judenstadt.\nAber Herr Ruschewey, wie er mir sagte, kam schon zum dritten Male,\nund zwar einer alten Geige wegen, die der jüdische Antiquar\nbesaß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(erhebt sich und öffnet den Schrank)")]), _vm._v(". Er hat sie\nbekommen, die alte Geige; hier ist sie, wenn es Sie interessiert.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Er nimmt einen geschlossenen Geigenkasten aus\ndem Schrank und stellt ihn auf den Tisch.)")]), _vm._v(" Aber das ist\nschon sehr lange her, daß Bertold diese Geige gekauft hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr.")]), _vm._v(" Im Kriegsjahre\neinundsiebzig war's. Ihr Herr Bruder war ein sehr lustiger Herr und\nbrachte den Juden oft zum Lachen; doch einig wurden sie lange\nnicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Ich weiß, es lag ihm\nsehr viel daran. Er hatte sich nämlich in den Kopf gesetzt, daß\ndiese Geige dieselbe wäre, die vor sehr vielen Jahrzehnten einmal\nmeinem seligen Vater gestohlen wurde. Unser seliger Vater war\nOrganist, und zwar drüben am alten Naumburger Dome; der hatte\nwieder das Instrument irgendwo, wer weiß, in der Sakristei oder\nGlockenstube oder sonstigem Heiligtume für Motten, Schaben und\nWürmer im Dome, und zwar in einzelnen Stücken, gefunden.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Er hat den Kasten geöffnet, die Seidentücher\nbehutsam vom Geigenkörper zurückgeschlagen.)")]), _vm._v(" Nur um's\nHimmels willen, daß Lux nicht kommt; sonst nimmt sie den Onkel bei\nden Ohren.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Gewiß gehört es der\njungen Dame.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Gewiß gehört's ihr, und\nzwar mit Recht: denn der andere Grund, weshalb er die Geige\nankaufte, war, daß Lux als sechs- oder siebenjähriges kleines Ding\nimmer ein Liedchen sang, das die Worte enthielt: »Eine kleine Geige\nmöcht' ich haben.« Sie hat auch seitdem recht wacker den Bogen\nführen gelernt. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page9",
      "title": "987/woldemar"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Das Fräulein Lux ist die\nwievielte?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Das Nestküken. Übrigens\nflügge genug!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Darf ich mir nun die\nFrage erlauben, wenn es nicht unbescheiden ist: Wird man die Damen,\nund wäre es für einen noch so kurzen köstlichen Augenblick, zu\nGesicht bekommen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Ich glaube nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Auch nicht, wenn man in\nder Lage ist, ihnen dies und das aus Persönlichem von der Begegnung\nmit ihrem Herrn Vater zu berichten?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Weiß der Deubel, die\nMädels sind scheuer als Holztauben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Ja, das hat man mir schon\nim Gasthause drüben in Naumburg gesagt, als ich mich nach der\nBesitzung erkundigte. Ich muß gestehen, es tut mir leid. – Ich\nhoffe, Sie nehmen es, wie es gemeint ist, wenn ich Ihnen mitteile –\nwir sind ja unter uns Männern, nicht? –, daß ich wohlsituiert,\nnicht ohne private Mittel, Junggeselle und überdies ordentlicher\nProfessor für klassische Philologie in Dorpat bin. Sie nehmen es\nmir gewiß nicht übel?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Alle Achtung! Wie käme\nich denn dazu!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Alle Achtung. Besonders,\nwenn man alles, wie ich als Kind armer Leute, durch eisernen,\nrastlosen Fleiß sich mühsam errungen hat. Ja. – Also: – »Wenn Sie\nProfessor sind« – richtig! sagte der arme Herr Ruschewey damals zu\nmir in Amsterdam, als wir so stillvergnügt miteinander die\nportugiesische Synagoge betrachteten –, »wenn Sie Professor\nsind, kommen Sie zu mir! Ich hab' eine hübsche Fasanerie«, setzte\ner noch mit Humor hinzu. »Sie wird Ihnen möglicherweise Spaß\nmachen.« – Den Augenblick habe ich leider verpaßt; denn als ich\nProfessor geworden war . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Wenn es Ihnen recht ist,\nHerr Professor, so gehen wir jetzt in den Garten hinaus, und ich\nlasse Sie gleich durch das untere Pförtchen. Sie gehen doch oben\nbeträchtlich um.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(". Ich bin Ihnen äußerst\nverbunden dafür. – Das heißt, ehe ich gehe, noch ein Wort. – Ich\nhabe die weite Reise gemacht . . . ich bin auch nicht mehr der\nAllerjüngste . . . Würde es vollkommen nutzlos sein . . . wir sind\nunter uns, unter Ehrenmännern! . . . mir schwebte, ich sage es frei\nheraus, die ältere von den Damen vor: ich benötige jemand "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page10",
      "title": "987/woldemar"
    }
  }), _vm._v(" gesetzteren\nAlters! . . . würde es nun ganz nutzlos sein, wenn ich fernerhin\nZeit und Mühe dransetzte . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Vollkommen nutzlos, ganz\nunbedingt.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Man hört flüchtige Rufe und plötzlich frisches,\nglockenartiges Gelächter von Mädchenstimmen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Herr")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(hat\nsich erhoben und eine Verbeugung gemacht)")]), _vm._v(". Verzeihen Sie\ngütigst, wenn ich gestört habe. – Es ist ein beschwerlicher Weg\nhierherauf.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ruschewey")]), _vm._v(". Auf runterzu geht es\nbedeutend leichter.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Er öffnet das Pförtchen, läßt den Herrn\nvorantreten und geht mit ihm ab.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Ludowike Ruschewey, ein schlankes fünfzehnjähriges\nMädchen mit kleinem Kopf, kommt leichtfüßig durch die Tür neben dem\nKamin. Als sie die Geige auf dem Tisch bemerkt, erschrickt sie und\nentrüstet sich dann.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Was bedeutet denn das?\nWer hat denn, gelinde gesagt, die Kühnheit besessen und hat meine\nVioline herausgeholt? "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Sie nimmt das Instrument\nheraus, betrachtet es und legt es zurück. Nun kommt durch die\ngleiche Tür wie sie Adelheid herein. Ludowike ruft ihr\nentgegen.)")]), _vm._v(" Hast du meine Geige in Händen gehabt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(die\nein gereiftes und schönes Mädchen ist, mit ausdrucksvollem Gesicht\nund fast südlichem Temperament und Feuer, antwortet\nleichthin)")]), _vm._v(". Aber, Dummchen, wie kommst du darauf? Tritt\nübrigens mal hinter den Vorhang. Onkel lotst wieder mal einen\nhinaus. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Sie späht, hinter dem Vorhang\nversteckt, durchs Fenster.)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(stellt sich sogleich neben die Schwester)")]), _vm._v(".\nO Gott, wie aus dem Beinhaus entsprungen! Ein Gesicht wie'n\nalter Schweinslederband!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Beinah wie'n Bruder von\nEwald Nast; oder find'st du den hübscher?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(sich\nschüttelnd)")]), _vm._v(". Brrr, Adelheid, bitte, verschone mich!\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Sie begibt sich wieder an ihre Geige, schließt\nden Kasten und stellt ihn in den Schrank.)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Willst du nicht gleich\netwas üben, mein Liebchen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(eine\npriesterlich segnende Gebärde flüchtig nachahmend.)")]), _vm._v(" Du\nauserwählete Jungfrau: nein!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Ja, mein liebes Kind,\nwarum denn nicht? Du hast noch ein hübsches Weilchen zu warten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Offen gesagt, eure\nErrungenschaften und Aussichten blenden mich eigentlich nicht; wie\nwirst du "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page11",
      "title": "987/Pirki"
    }
  }), _vm._v("\nheißen? Nicht mal Frau von Kranz, bloß Frau Kranz wirst du heißen!\nRuschewey klingt doch zehnmal so gut, und wir haben außerdem einen\nStammbaum. Ganz hübsch sah zum Beispiel der Rittmeister aus, als\ndie Leutnants neulich zu Pferde herauskamen! – Aber Agathe ist doch\nblind! die sieht doch die schönsten Beine nicht. Bleibt also ihr\nPädagoge Ewald: eh ich den nähme, würde ich Nähterin.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(drollig betroffen)")]), _vm._v(". Seh' einer bloß dies Küken an!\n– Ich werde dir nochmals Konfekt mitbringen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Jetzt sage mal ehrlich,\nAdelheid: was soll ich eigentlich davon haben, daß du dich zum\nBeispiel nächstens verheiratest? Na ja; auf der Hochzeit werde ich\ntanzen! Aber nachher, gleich, da verliert man dich doch! Oder sieh\nmal Agathe an . . . früher war sie gesellig und heiter – seit sie\nverlobt ist, ist sie meistens verstört und menschenscheu.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Ist sie denn überhaupt\nverlobt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Ja, würde denn Ewald sie\nsonst so martern? Das müßt ihr doch sehen, er martert sie doch! Er\nmacht sie doch reinwegs krank und schwermütig. Was gehen mich denn\neure Bräutigams an, wenn sie einem Geschwister abspenstig machen!\nIhr tut einem einfach ganz schauderhaft leid: ihr tut ja doch\nkeinen Atemzug, den sie euch nicht genehmigt haben! Und früher, da\nwart ihr frei wie der Wind.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(knicksend)")]), _vm._v(". Au contraire! Erst jetzt ist man frei\ngeworden.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Die Tür neben dem Schrank wird hinter dem Rücken\nder Mädchen vorsichtig geöffnet, und ein Mann mit zerlaufenen\nSchuhen, geflickten Sachen, Knotenstock und verwegenem Kalabreser\ntritt ein. Er hat eine grobe Ledertasche umgehängt. Sein\nziegenbockartiges Gesicht ist mit Sommersprossen bedeckt, übrigens\nnicht uninteressant. Haupt- und Barthaar rötlich. Das Alter des\nVagabunden kann etwa fünfunddreißig Jahre betragen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Ich möchte mir eine\nFrage erlauben.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(fährt\nerschrocken herum)")]), _vm._v(". Um Gottes willen! Was wollen Sie\ndenn?")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Ludowike ist nach der Klingelschnur gelaufen und\nhat sie heftig gezogen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Bei Gott, meine\nDamen, ich will weiter nischt. Ich mechte mir bloß die Frage\nerlauben: Wo geht denn der Weg nach Merseburg? "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page12",
      "title": "987/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Wie sind Sie denn hier\nhereingekommen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Auf Ehre, das weiß\nich alleene nich! Erschtlich bin ich durch Gestrippe gestiegen,\ndann bin ich durch einen Weinberg runtergekomm'n, dann auf einen\nbreiten Gartenweg, dann in eine scheene Eintrittshalle, dann durch\neinen scheenen Speisesaal, dann über ein kleines Treppchen rauf,\nund nu mechte ich gerne in meine Heimat.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Adelheid und Ludowike blicken bald den seltsamen\nEindringling, bald einander an und brechen schließlich in\nherzhaftes Lachen aus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Wo ist Ihre Heimat\neigentlich? Doch nicht etwa vielleicht unsere Speisekammer!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Nein. Usingen ist\nmein Heimatland.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Hast du den Namen schon\njemals gehört, Lux?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Non, mon enfant.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Ce n'est rien que\nSilésie, mesdames.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Sie sprechen\nFranzösisch?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". C'est ça. Ich bin ein\nJahr lang in Algier gewesen: ich war nämlich Fremdenlegionär! Dann\nhab' ich mich aber kleene gemacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(ruft\ndurchs Fenster hinunter)")]), _vm._v(". Da ist Otto! Otto, komm doch mal\nrauf! Wir haben Besuch aus Algier bekommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Ich kann Ihn'n meine\nPapiere zeigen. Uff Parole d'honneur; ich beschwindle Ihn'n nich.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Er kramt in seiner Tasche herum, die er ohne\nUmstände auf den Tisch legt.)")])]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Durch die Tür an der Kaminwand tritt der\nsiebzehnjährige Otto Kranz, ein Bruder von Adelheids Bräutigam. Er\nträgt sich idealisch, mit Schnallenschuhen, fliegenden\nKrawattenenden und langem Haar.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(übermütig)")]), _vm._v(". Erlauben die Herren, daß ich vorstelle:\nHerr Otto Kranz, sculpteur de talent de Munic, und . . .?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Ich bin ein geborener\nKlemt! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Nach gravitätischer Verbeugung.)")]), _vm._v("\nUnd nu darf ich vielleicht zur Sache kommen. Das ist doch hier\nnämlich ein altes Haus. Das hab' ich nämlich von weitem gesehen,\nwie das mit dem hohen Dache so hoch aus a Linden und aus a\nKastanien und aus a Nußbäumen rausgucken tutt, daß das hier a alter\nKasten sein muß. Und solche Geniste, die sein was für mich: von\nBeruf bin ich nämlich Kammerjäger. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page13",
      "title": "987/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(ohne\nweiteres laut)")]), _vm._v(". Wie hat sich der Kerl denn hier\neingeschlichen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Kerl? I nee, weeß\nKneppchen. Da irren Sie sich! Ich geh' Ihn'n meinem Gewerbe nach,\nwie ein Jagdhund, Sie, wie ein richtiger Finder. Und da find' ich\nooch stets was und täusche mich nich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". Ihr Gewerbe dürfte das\nSchnorren sein! – Kommen Sie mit! – Ich werde ihn raussetzen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". Und Ratten und Mäuse\nhätten Se nich? Und Kreuzottern keene in Ihrem Weinberg? Und\nSchlüffel nich? Und o Schwaben nich? Kee Ungeziefer im ganzen\nHause? O keene schwarzen Husaren, mesdames?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". Es ist bloß ein Hund hier,\nder Schweizer heißt! Ein ziemlich bissiger Bernhardiner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Der Vagabund")]), _vm._v(". De Schweizer sein\ngude Suldaten. Jawohl! – Also nischt nich fer ungutt! C'est ça,\nmesdames. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Er geht, von Otto eskortiert; an der\nTür wendet er sich nochmals und blinzelt pfiffig nach den\nvergoldeten Gefäßen hin, die den Tisch schmücken.)")]), _vm._v(" Scheene\nGoldschmiedearbeit hab'n Se da stehn! Da lacht einem alten\nSchnapphahn das Herze! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Gefolgt von Otto,\nab.)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(ironisch)")]), _vm._v(". Otto ist heut gar nicht bei Humor. Ich\ndachte, der Mensch müßte ihm doch Spaß machen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Ich hab' ihn beim\n»Arbeiten« aufgestört. Er zeichnete oder schrieb Gedichte. – Macht\ndein Bräutigam denn auch Gedichte?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(ironisch)")]), _vm._v(". Leider nein! Otto hält sich für das\nGenie der Familie!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Dann hätte ich doch Otto\ngenommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Das Kind?")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Ludowike, im Begriff davonzueilen, trifft in der\nTür auf Otto und Sabine.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Habt ihr gesehen? Der\nwollte mich! Wie steh' ich da: wieder ein neuer Antrag! Schon vier\nAnträge hat Onkelchen mir verpfuscht! Nächstens werd' ich ihm mal\ngründlich das Ohrläppchen kneipen! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Heiterkeit.)")]), _vm._v(" Wißt ihr nicht, wo Agathe ist? – Otto,\nhat sie dir nicht heut morgen gesessen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". Ja. Ich habe bis etwa vor\neiner halben Stunde unten im Winzerhaus modelliert; dann plötzlich,\nich weiß nicht, kam der Briefträger, und da stand sie plötzlich auf\nund verschwand. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page14",
      "title": "MEsswein/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Ich habe sie mindestens\neine halbe Stunde lang im Garten gesucht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Gib Geld, Sabine, es sind\nwieder Sendungen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Du, deine Ausstattung macht\nuns bankerott.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Dann erben wir wieder von\nGroßmama.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Möglicherweise ist Ewald\ngekommen, und sie muß ihm wieder irgendeinen albernen\nVerschönerungsvereins-Jahresbericht oder sonst was ins reine\nschreiben. Oder Vermögenssachen von Tante Emilie, die er doch ganz\nin den Klauen hat.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Pfui, Lux, wer wird von\nKlauen reden! Vor zwölf kommt er übrigens nicht heraus; denn bis\nelf Uhr dauert sein Unterricht. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Halblaut zu\nAdelheid.)")]), _vm._v(" Ich muß dir mal etwas leise sagen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". O bitte, laut, ich störe euch\nnicht. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Er geht ab.)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Otto! Warum denn? Bleib\ndoch gefälligst.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(neugierig)")]), _vm._v(". Laß ihn doch ruhig. Das schadet ihm\nnichts. – Was gibt's denn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Nichts, als daß Dr.\nGrünwald im Schwarzen Roß zu Naumburg ist mit seinem alten Freund\nKozakiewicz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(die\nsich neugierig herangeschlichen hat.)")]), _vm._v(" – Wer?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Papperlapapp, du\nKiekindiewelt!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(in\nhöchstem Erstaunen)")]), _vm._v(". Aber nein, Sabine, das glaube ich dir\nnicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Ja nun, das wird die Sache\nnicht ändern. Erkundige dich doch mal beim Onkel darum.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Sie kniet, schließt ein Schrankfach auf und\nkramt darin.)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(händeringend, in einer Art humoristischer\nVerzweiflung)")]), _vm._v(". Aber, Mädels, um Gottes und Christi willen:\nwas wird denn jetzt bloß Agathe tun?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Was ist denn das nun für\neine Geschichte?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(zu\nSabine mit Bezug auf Agathe)")]), _vm._v(". Weiß sie es schon? Ich denke\ndoch nicht. Wenigstens läßt sie sich nichts merken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". I, da muß eben wieder\nOnkelchen einspringen. Die Sache ist eben doch abgetan.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Leutchen, wenn ihr so\nweiter in Rätseln sprecht, dann bin ich ja eigentlich\nüberflüssig.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(lustig)")]), _vm._v(". Das bist du auch. Immer marsch, fort mit\ndir.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Gerade nicht! Ich bin alt\ngenug! Und wenn ihr wollt meine Schwestern sein, so habt ihr vor\nmir auch keine Geheimnisse. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page15",
      "title": "987/Pirki"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Sabine, das glaub' ich\ndir nimmermehr: das ist wieder einer deiner Scherze. Der ist ja\ndoch in Amerika, wer weiß wo, untergetaucht und verschollen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Na, und jetzt ist er eben\nzurück und sitzt fuchsmunter im Roß zu Naumburg.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Wenn ihr denkt, daß ich\ndie Geschichte nicht weiß, so seid ihr doch recht sehr\nschiefgewickelt.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Dummchen, was für 'ne\nGeschichte denn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Warum war denn Agathe\nimmer so schwermütig? Weil sie keinen Brief mehr von ihm bekam!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(leichthin)")]), _vm._v(". Von wem denn?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Na, von dem\nAmerikaner.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Du hast was läuten hören,\nmein Kind.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Und dann hat sie aus Wut\noder was weiß ich dem Schulmeister ihre Seele verkauft.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Pst, liebe Lux: sprich\nkeine Torheiten! Im Grunde geht uns das alles nichts an, und man\nmuß jedem sein Seelenheil selbst überlassen. Du bist übrigens\ntatsächlich alt genug, und's ist besser – meinst du nicht auch,\nAdelheid? –, du weißt, wie die Sachen wirklich sind! Du kannst\ndann vielleicht Taktlosigkeiten vermeiden, statt daß du aus\nUnwissenheit welche begehst. Agathens Empfindlichkeit ist ja fast\nsprichwörtlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Also wirklich? Grünwald\nist drüben in Naumburg?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Er hat bei Onkelchen\nangefragt, ob sein Besuch uns genehm sein würde.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Und wenn er mit Ewald\nzusammentrifft!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Nun was? Es sind doch\ngebildete Menschen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Ich verstehe die Sache\nnoch immer nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". So, nun zeige dich mal der\nSache gewachsen; Grünwald ist der gewesene Marinearzt, von dem du\nsicher schon oft gehört hast. Papa jedenfalls sprach öfters von\nihm. Zwischen ihm und Agathe hat etwas geschwebt. Sie lernten sich\nkennen auf Sylt im Seebad. In einem Sommer, du weißt es ja doch,\nwaren Papa, ich und Agathe in Westerland.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Vorsicht, daß uns Agathe\nnicht hört.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Oder Ewald, er muß jeden\nAugenblick kommen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Sie waren also ganz\nrichtig verlobt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Verlobt und auch nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Wie geht denn das?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Eigentlich waren sie\nversprochen, und andererseits waren sie auch wieder frei. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page16",
      "title": "987/DaoH"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(indem\nalle drei die Köpfe immer geheimnisvoller zusammenstecken)")]), _vm._v(".\nLiebchen, hast du nicht manchmal bemerkt, daß Agathe gegen den\nseligen Papa einen gewissen Groll in der Seele trägt?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Du weißt ja, ich wurde\nsogar mal heftig! Papas Andenken lass' ich mir einmal nicht\nantasten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Agathe tut das im Grunde\nauch nicht. Aber Papa hat damals zu Grünwald gesagt, er solle sich\nnoch zwei, drei Jahre herumtummeln und dann werde es Zeit zu der\nFrage sein, die er ihm jetzt nicht beantworten könnte.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". O weh, lieber Papa, da\nging' ich durch!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Und jetzt kannst du dir\nwohl auch einen Begriff machen, was Agathe inzwischen gelitten hat.\nBriefe hatte Papa verboten. Mündlich hatten die beiden abgemacht:\nein Lebenszeichen nach Verlauf jedes Jahres!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Er sollte schreiben!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Er schrieb aber nicht.\nDer Termin kam heran, und er blieb verschollen. Dann starb Papa,\nund es rührte sich nichts. Dann kam ihre Krankheit und Ewalds\nWerbungen und Tante Emiliens Apparat . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Und nun wieder ist Grünwald\nauf einmal da und, wer weiß, erscheint vielleicht auf der\nBildfläche.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". – Sabine, du hast doch\nwohl Spaß gemacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(achselzuckend)")]), _vm._v(". Mit solchen Sachen ist nicht zu\nspaßen! Denkt, was ihr wollt, bloß verschnappt euch nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Oberlehrer Dr. Ewald Nast tritt ein. Er trägt\nGehrock, Zylinder und schwarze Krawatte, sehr blankes, aber plumpes\nSchuhwerk. Die Kleider, von einem Provinzschneider gemacht, sind\nlange getragen, aber gut gehalten. Nast hat einen Sommerüberzieher\nüberm linken Arm, in der gleichen Hand einen Schirm, in der rechten\nden Zylinder, im Munde einen Zigarrenstummel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(laut und\nselbstbewußt auftretend)")]), _vm._v(". Guten Morgen, ihr Mädchen, ein\nprachtvoller Tag! – Ich komme vom Zahnarzt direktement! einen\nBackenzahn, drei scheußliche Wurzeln! mich gehalten wie Mucius\nScaevola! Nur muß ich noch meinen Stummel ausrauchen. Tabak\nbekanntlich desinfiziert. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Scherzhaft zu\nLudowike.)")]), _vm._v(" Nicht wahr, meine Gnädige?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Und stinkt auch\nbekanntlich.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Das kommt immer auf die\nZigarre an.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Die Ihrige kostet ja wohl\nsechs Pfennige. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page17",
      "title": "987/lesdochmal"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Cousin und Cousine: ich\nerbitte das Du. Ich zweifle nicht, daß es bessere gibt! Nun, man\nmuß sich nach seiner Decke strecken. Wie geht's unsrer lieben\nAgathe, gut?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Ich habe sie heute noch\nkaum gesprochen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Nun, ich werde gleich selbst\nzum Rechten sehn! Je mehr ich mich in die Sache hineindenke, je\nmehr macht mir die kommende Hochzeit Spaß. – Die Schüler hatten\nheut Klassenarbeit, und während ich auf dem Katheder saß, da hab'\nich mir etwas ausgesonnen, was dich, liebe Adelheid, freuen wird.\nIch meine an deinem Ehrenabend.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Ich lasse mich\nüberraschen, nur zu!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ist dein kleiner Schwager\neigentlich anstellig?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Inwiefern, Ewald, soll er\ndenn anstellig sein?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Erstlich brauche ich jemand,\nder mir mein kleines Versspiel ins reine bringt . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(". Ihre Verse abschreiben?\nDas tut Otto nicht. Dazu ist er zu stolz. Er macht selber\nwelche.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Oh! Messer, Gabel, Schere,\nLicht ist für kleine Kinder nicht. Doch immerhin – lassen wir ihm\ndas Vergnügen, ein bißchen Herzen und Schmerzen zu reimen, wenn nur\nniemand dabei beschädigt wird; auch macht mir Agathe schließlich\ndie Reinschrift, doch hätte ich etwas anderes für ihn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Besprich es doch mit ihm\nselber, Ewald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Nur nicht in Adelheids\nGegenwart.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Adelheid")]), _vm._v(". Ich muß sowieso zu den\nWeißnähterinnen. Ich habe drei Nähterinnen im Haus. Wenn ich Otto\nsehe, will ich ihn reinschicken.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Vielleicht, daß er doch die\nGnade hat! "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Adelheid ab.)")]), _vm._v(" Sonst nehme\nich einen meiner Quartaner. – Übrigens: Euren Gärtner solltet ihr\nabschaffen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Warum?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Weil er dreist und untüchtig\nist. Ich hatte eben mit ihm beinah ein Renkontre.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Onkel hält ziemliche Stücke\nauf ihn.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Laissez aller: das ist Onkels\nGrundsatz. Ich sage euch: schafft diesen Gärtner ab! Und ihr werdet\nes tun, trotz des guten Onkels und seiner strafwürdigen\nBonhomie.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Was hat's denn gegeben mit\ndem Gärtner?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ich muß mich ein bißchen mit\nReden in acht nehmen. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Er faßt nach der\nBacke.)")]), _vm._v(" Er benimmt sich gegen mich flegelhaft, und zwar bei\njeder Gelegenheit. Und dann begeht der Mensch gradezu Tollheiten.\n"), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page18",
      "title": "vipi/woldemar"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Wieso?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ich nenne es eine Tollheit,\nSabine, wenn er einen Burschen hier bei sich hat – ich meine in\neurem Garten beschäftigt –, ein Subjekt, das mehr als\nverdächtig ist! Einen Kerl, der am gestrigen Nachmittag bereits\nunser Naumburg unsicher machte, bis er schließlich auch meine zwei\nTreppen erstieg, wo ich ihm aber gehörig den Text geigte. Mir sagte\nder Mensch, er sei Scharfrichterknecht; – und hier läßt ihn der\nGärtner Maulwürfe wegfangen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Ach, es sind ja doch Männer\nim Haus, guter Ewald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Wenn ihr töricht sein wollt,\nich dulde es nicht. Entweder der Onkel setzt ihn raus, oder ich\nwerde die Polizei verständigen. Am besten, der Gärtner fliegt\ngleich mit; denn er betrügt euch, wenn ihr die Augen wegwendet.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Papa machte immer einen\nbestimmten Abstrich auf Betrug.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Das konnte Papa, ihr dürft\ndas nicht. Das hieße ja unverantwortlich wirtschaften! Man wirft\ndoch das Geld nicht zum Fenster hinaus.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Ludowike")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(indem\nsie, sich räkelnd, hinausgeht)")]), _vm._v(". Wenn man welches hat, warum\nsoll man's nicht rauswerfen. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Ab.)")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Oh! oh! oh! oh! Der Tausend\nnoch mal! An Lux ist viel gesündigt worden! Es rächt sich, wo eine\nstrenge und konsequente Erziehung gebricht!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Aber, Ewald, das sind doch\nnur harmlose Unarten.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ihr glaubt es mir nicht! Ihr\nglaubt es mir nicht. Ihr laßt dem Kinde sträflich viel Freiheit.\nDarin hat Tante Emilie vollkommen recht. Eines Tages, sag' ich\neuch, muß es sich rächen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Hu, hu! Das klingt aber\nfürchterlich!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ihr glaubt, ihr seid niemand\nverantwortlich, weil ihr unabhängig hier oben lebt. Ihr seid für\ndas Freie und Ungebundene; aber wenn ihr manchmal zu hören bekämt,\nwas drüben in Naumburg von euch gesagt wird, dann würdet ihr sehn,\ndaß die Welt nicht schläft und daß niemand so unabhängig ist, um\nsich auch nur im geringsten Punkt ungestraft gegen sie zu\nversündigen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Ei! ei! ei! ei! Was\nbedeutet denn das?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Liebste Muhme, wir wollen das\nKriegsbeil nicht ausgraben. Ich hoffe, du mißverstehst mich nicht.\nMeine brave Agathe denkt ganz wie ich; und ich sehe den Tag in\nnicht weiter Ferne, wo auch du, eigentlich der Verstand der\nFamilie, "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page19",
      "title": "987/woldemar"
    }
  }), _vm._v(" auf\ndie mittlere Linie der Lebensführung zurückkommen wirst.\n"), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Otto tritt ein.)")]), _vm._v(" Jetzt wollen wir uns\nden Präliminarien froher Stunden widmen. – Sage doch mal, du junger\nAdonis von sechzehn Lenzen! Ich hätte eine Sache für dich. – Du\nwirst ja bleich: erschrick nur nicht. Du sollst ja nicht mensa\ndeklinieren! Es handelt sich nur um einen Scherz.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". Wäre ich dabei unbedingt\nnotwendig?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Niemand, mein Sohn, ist\nunbedingt notwendig. Also hör mal, was ich eigentlich will. Du\nweißt, was Scherz ist.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". Ich hoffe doch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ich auch. Also werden wir uns\nbald einigen. – Ich habe nämlich ein Festspiel verfaßt, und in\ndiesem Festspiel sind nur zwei Rollen, und die dritte . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Ich denke, es sind bloß\nzwei?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Und die dritte, junger\nFreund, sollst du darstellen. »Peter Squentz« von Gryphius kennst\ndu nicht . . . ich will lieber etwas weiter ausholen. Dieses Haus\nhier hat früher zum Dom gehört. Eigentümerin war das Domkapitel,\nund Domherren haben es früher bewohnt, Bischof Throta sogar,\nKirchenfürsten mitunter, und das Wappen, das sich am Kamin noch\nvorfindet, trägt einen Palmesel, Stab und Bischofshut. Es handelt\nsich aber nur um den Palmesel.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Soll Otto den Palmesel etwa\ndarstellen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Die dritte, sehr lustige\nRolle ist stumm in der Tat und wäre allerdings quasi der\nPalmesel.")]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Sabine stutzt einen Augenblick und bricht dann in\nhelles Gelächter aus. Nast seinerseits stutzt zunächst ebenfalls,\nund zwar über das Gelächter, von dem fortgerissen er, allerdings\netwas gezwungen, schließlich mitlacht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(verbeißt\nsichtlich den Ärger über die Verletzung seines Selbstgefühls und\nsagt dann ruhig)")]), _vm._v(". Das Fach des Clowns, Herr Oberlehrer,\nliegt mir nicht. Aber da ich Bildhauer bin, würde ich mich gern\nanheischig machen, einen Palmesel nach dem Leben, sehr\nporträtähnlich, zu modellieren. Wenn gebrüllt werden soll, macht\ndas ein Hausknecht vielleicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ah, aha! Ist man der\njugendlichen Überhebung und Eitelkeit doch wieder einmal zu nahe\ngetreten. Es gibt heute keine Jugend mehr.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". Das liegt dann vielleicht an\nihren Erziehern.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Lassen wir das! Keine\nKontroversen! Es steht dir nicht! Und mir würde es nun schon gar\nnicht geziemen, mit dir "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page20",
      "title": "987/woldemar"
    }
  }), _vm._v(" um ernsthafte Fragen zu streiten. Das\nMißverhältnis wäre zu kraß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Otto")]), _vm._v(". Weshalb duzen Sie mich denn\neigentlich?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Mein Freund, Ihnen fehlt die\nNaivität. Denken Sie an die Fastnachtsspiele! Denke doch an den\nMeister Hans Sachs! Denke doch an die alte Tierfabel, an den Weber\nZettel im »Sommernachtstraum«! Einen Esel naturgetreu darzustellen,\nbraucht einer durchaus kein Langohr zu sein.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(". Liebe Festgenossen in spe,\nentzweit euch nicht. Es empfiehlt sich, bei gutem Humor zu bleiben;\ndenn ein guter Humor ist ja doch der Zweck.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Dieser Dummstolz, der keinen\nSpaß versteht, Gespreiztheit! Unreife mit Prätentionen! Was mir\npeinlicher wäre, wüßte ich nicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Sabine")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(legt\nden Arm um Otto)")]), _vm._v(". Komm, Otto, den Herrn Vetter lassen wir\nauspoltern. Er hat heute, scheint's, seinen reizbaren Tag. Die\nSchuljungen haben ihn wohl geärgert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(mit\narroganter Heiterkeit)")]), _vm._v(". O nein, schöne Muhme, da irrst\ndu dich. Ein Schuljungenstreich geniert keinen Weisen. So was stört\nmeine Götterlaune nicht. "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(Sabine mit Otto\nab.)")])]), _vm._v(" "), _c('p', {
    staticClass: "stage"
  }, [_vm._v("Agathe, ein schöngewachsenes, etwas\nbleichsüchtiges, üppiges Mädchen, tritt durch die Tür an der\nSchrankseite. Das hellblonde Haar umrahmt, schlicht gescheitelt,\ndas ovale, großäugige, süße Gesicht, das einen Zug von Schwermut\nhat. Die Bewegungen Agathens sind weich und geräuschlos. Ihr Gang\nrhythmisch und wie schwebend. Sie hüllt sich, wärmebedürftig, in\nein Spitzentuch.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Guten Morgen, Ewald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Da bist du ja! – Um Gottes\nwillen, wie siehst du denn aus?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(an sich\nhinuntersehend)")]), _vm._v(". Wie? ist etwa wieder ein Saum gerissen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Ist dir nicht wohl, mein\ngutes Kind?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Weshalb sollte mir denn\nnicht wohl sein, Vetter?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Vetter? Was ist das für ein\nWort?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Es ist doch ein Wort, das\ndir auch zukommt, Ewald.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Nun, Liebe, ich verzichte\ndarauf. Dafür will ich dich auch nicht Cousine nennen. – Aber sag\nmir nur endlich, was mit dir ist!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Wieso? – Ich weiß dir\ndarauf nicht zu antworten. –")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Du hast geweint! "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page21",
      "title": "987/woldemar"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Ich habe durchaus nicht\ngeweint, lieber Ewald. Und wenn . . . warum sollte ich schließlich\nnicht?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". – Du siehst, ich fasse mir an\nden Kopf! Ich komme noch gar nicht zu mir selber! Was ist denn auf\neinmal mit dir passiert?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Nichts. Gar nichts, Ewald.\nNicht das geringste. Ich bin eben mit Onkel Gustav\nspaziert . . .")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Und was habt ihr da\nmiteinander gesprochen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Nichts! Sicherlich nichts,\nwas dich interessiert.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". So?! Und du glaubst, so lass'\nich mich abspeisen?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Ach, Ewald, bitte! Du\npeinigst mich. Du mußt mir ein wenig Ruhe lassen.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". – Wann hätte ich deine Ruhe\ngestört? – Willst du mich jetzt nicht sehen, Agathe, so sage es\nnur. – Du hast Anspruch auf jegliche Rücksichtnahme, als Patient\nund als Rekonvaleszent.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(geht\nheftig umher)")]), _vm._v(". Ich bin nicht mehr leidend! So laß doch nur\ndas! Weshalb mußt du es mir denn täglich vorhalten? Ich bin so wie\njeder andere Mensch und verlange durchaus keine größere\nRücksicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Der alte Irrtum, die alte\nNot! Wenn dir freilich mein Rat irgend etwas gilt und die Zukunft,\nder wir entgegeneilen – ich kann nicht anders! es tut mir\nleid –, so laß uns, ich bitte dich wieder darum, doch endlich\nmit festen Entschlüssen hervortreten! Dieser Zustand martert uns\nbeide nur.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". – Nun auf einmal wiederum\ndiese Wendung.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Jawohl, mit vollem\nBewußtsein, Kind. – Ich kann warten, ich bin nicht ungeduldig, auch\nan deinem Charakter zweifle ich nicht. Auch daß eure Verhältnisse\nglänzende sind, ist ein Umstand, der mich nicht weiter beeinflußt.\nIch bin genügsam und habe mein Auskommen. Nein! Aber wir sind in\nder Leute Mund . . . und ich weiß eigentlich nicht, worauf wir noch\nwarten. – Oder, Agathe, treibst du dein Spiel mit mir?")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(". Wie kannst du bloß so etwas\ndenken, Ewald!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Nun gut, ich denke es\neigentlich nicht. Ja, das Gegenteil ist mir durchaus Gewißheit.\nVorwärts! Zögern wir also nicht! – Du schweigst. – Es ist immer das\ngleiche Schweigen, das du mir, sooft ich bis jetzt auf diese Sache\ngekommen bin, wie eine Mauer entgegenstellst. Ich kann mir dieses\nSchweigen nicht ausdeuten. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page22",
      "title": "987/woldemar"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(nach\neinigem Stillschweigen)")]), _vm._v(". Ewald, du brauchst eine Frau, die\ntüchtig . . . jedenfalls anders ist! Was willst du mit jemand, wie\nich bin, anfangen, der so mit sich selber uneins ist, so untüchtig\nund so verkehrt erzogen. Du kannst mir glauben, du kennst mich\nnicht.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Du leidest an einer gewissen\nPusillanimität: an sonst nichts! Das ist meine Sache; darauf lasse\nich es ankommen. Hast du nur einige Neigung zu mir, so wollen wir\nuns schon darüber hinwegsetzen. Also, beste Agathe, – "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(er faßt ihre Hand)")]), _vm._v(" – entschließe dich!")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Agathe")]), _vm._v(" "), _c('span', {
    staticClass: "regie"
  }, [_vm._v("(bewegt\nund mit Überwindung)")]), _vm._v(". Nun, Ewald, in einer Zeit, wo sich\nwirklich keine Menschenseele auf Erden um mich gekümmert hat, wo\nich körperlich und auch geistig völlig daniederlag, hast du allein\nunter allen Menschen dich um mich gekümmert! Du allein nahmst dich\nmeiner an. Gut also: ich bleibe dir also nichts schuldig. – Du\nnimmst mich selbst ja als Ausgleich an. Also sei es! Das übrige\nmußt du verantworten: nämlich, wenn es zu deinem Guten nicht ist. –\nJetzt aber . . . um eines ersuch' ich dich noch . . . es ist\njemand . . . Dr. Grünwald ist wieder aufgetaucht . . . ich habe dir\nniemals was angedeutet . . . möglicherweise hast du doch etwas\nmunkeln gehört . . . er darf unter keiner Bedingung heraufkommen!\nJedenfalls werde ich ihn unter keiner Bedingung wiedersehen. – Und\ndavor mußt du mich schützen, Ewald, daß ich diesen Entschluß etwa\nbrechen muß.")]), _vm._v(" "), _c('p', {
    staticClass: "calibre1"
  }, [_c('span', {
    staticClass: "speaker"
  }, [_vm._v("Nast")]), _vm._v(". Wie? Was? – Du kennst mich;\nich werde alles veranlassen. "), _c('a', {
    staticClass: "pcalibre2 pcalibre3 pcalibre1 pcalibre",
    attrs: {
      "id": "page23",
      "title": "987/woldemar"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a61bab10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/Section0003.vue
// module id = 63
// module chunks = 0